import { Link } from "react-router-dom";

export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20waterproofing%20work%20on%20flat%20rooftop%2C%20workers%20applying%20bituminous%20membrane%20on%20large%20commercial%20building%20roof%2C%20torch-applied%20waterproofing%20installation%2C%20industrial%20roofing%20project%2C%20wide%20angle%20aerial%20view%2C%20overcast%20sky%2C%20professional%20BTP%20etancheite%20photography&width=1440&height=900&seq=ksbtp-hero-etanche001&orientation=landscape"
          alt="KS BTP - Expert en Étanchéité"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#00a340]/60 bg-[#00a340]/10 mb-5 md:mb-8">
            <span className="w-2 h-2 rounded-full bg-[#00a340] inline-block"></span>
            <span className="text-[#a8f0c0] text-xs font-semibold tracking-widest uppercase">Spécialiste en Étanchéité</span>
          </div>

          {/* Headline */}
          <h1 className="text-3xl md:text-6xl font-extrabold text-white leading-tight mb-4 md:mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Expert en{" "}
            <span className="italic text-[#4cd97a]">Étanchéité</span>
            {" "}&amp;{" "}
            <span className="italic text-[#4cd97a]">Imperméabilisation</span>
            <br />
            <span className="text-white">de tous types de bâtiments</span>
          </h1>

          <p className="text-gray-200 text-sm md:text-lg leading-relaxed mb-7 md:mb-10 max-w-xl text-justify">
            KS BTP est votre partenaire de confiance pour tous vos projets d&apos;étanchéité. Nous utilisons des matériaux parfaitement adaptés à la nature de vos projets et aux contraintes climatiques de la région, avec un savoir-faire reconnu et un engagement total envers la qualité.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
            <Link
              to="/devis"
              className="px-6 md:px-8 py-3 md:py-3.5 rounded-md bg-[#00a340] text-white font-semibold text-sm whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer text-center"
            >
              Demander un devis gratuit
            </Link>
            <button
              onClick={() => handleScroll("#metiers")}
              className="px-6 md:px-8 py-3 md:py-3.5 rounded-md border border-white/50 text-white font-semibold text-sm whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              Nos domaines d&apos;étanchéité
            </button>
          </div>
        </div>

        {/* Stats floating card */}
        <div className="absolute bottom-12 right-8 hidden lg:flex gap-6">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-6 py-4 text-center">
            <div className="text-3xl font-black text-white">26+</div>
            <div className="text-xs text-gray-300 mt-1">Ans d&apos;expérience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-6 py-4 text-center">
            <div className="text-3xl font-black text-[#4cd97a]">500+</div>
            <div className="text-xs text-gray-300 mt-1">Chantiers réalisés</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-6 py-4 text-center">
            <div className="text-3xl font-black text-white">100%</div>
            <div className="text-xs text-gray-300 mt-1">Clients satisfaits</div>
          </div>
        </div>
      </div>
    </section>
  );
}
